import React, { useState } from 'react';
import Header from '../components/Header';
import NavigationMenu from '../components/NavigationMenu';
import Card from '../components/Card';
import Input from '../components/Input';
import Button from '../components/Button';
import { UserIcon, KeyIcon, BellIcon, HelpCircleIcon, FileTextIcon } from 'lucide-react';
const Profile = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const handleMenuToggle = () => {
    setMenuOpen(!menuOpen);
  };
  return <div className="min-h-screen bg-gray-50" data-id="element-310">
      <Header username="Carlos Pérez" onMenuClick={handleMenuToggle} notificationCount={3} data-id="element-311" />
      <NavigationMenu isOpen={menuOpen} onClose={() => setMenuOpen(false)} data-id="element-312" />
      <main className="p-4 pb-20" data-id="element-313">
        <h1 className="text-xl font-semibold mb-4" data-id="element-314">Configuración y Perfil</h1>
        {/* Profile Info */}
        <Card className="mb-6" data-id="element-315">
          <div className="flex items-center mb-4" data-id="element-316">
            <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mr-4" data-id="element-317">
              <UserIcon size={32} className="text-blue-600" data-id="element-318" />
            </div>
            <div data-id="element-319">
              <h2 className="font-semibold text-lg" data-id="element-320">Carlos Pérez</h2>
              <p className="text-gray-600" data-id="element-321">Gestor Financiero</p>
            </div>
          </div>
          <Button fullWidth data-id="element-322">Editar perfil</Button>
        </Card>
        {/* Security */}
        <Card className="mb-6" data-id="element-323">
          <div className="flex items-center mb-4" data-id="element-324">
            <KeyIcon size={20} className="text-blue-600 mr-3" data-id="element-325" />
            <h2 className="font-semibold" data-id="element-326">Seguridad</h2>
          </div>
          <Input label="Contraseña actual" type="password" placeholder="Ingrese su contraseña actual" data-id="element-327" />
          <Input label="Nueva contraseña" type="password" placeholder="Ingrese su nueva contraseña" data-id="element-328" />
          <Input label="Confirmar contraseña" type="password" placeholder="Confirme su nueva contraseña" data-id="element-329" />
          <Button fullWidth data-id="element-330">Cambiar contraseña</Button>
        </Card>
        {/* Notifications */}
        <Card className="mb-6" data-id="element-331">
          <div className="flex items-center mb-4" data-id="element-332">
            <BellIcon size={20} className="text-blue-600 mr-3" data-id="element-333" />
            <h2 className="font-semibold" data-id="element-334">Notificaciones</h2>
          </div>
          <div className="space-y-4" data-id="element-335">
            <div className="flex items-center justify-between" data-id="element-336">
              <div data-id="element-337">
                <div className="font-medium" data-id="element-338">Notificaciones push</div>
                <div className="text-sm text-gray-600" data-id="element-339">
                  Recibir alertas en su dispositivo
                </div>
              </div>
              <label className="relative inline-flex items-center cursor-pointer" data-id="element-340">
                <input type="checkbox" className="sr-only peer" defaultChecked data-id="element-341" />
                <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600" data-id="element-342"></div>
              </label>
            </div>
            <div className="flex items-center justify-between" data-id="element-343">
              <div data-id="element-344">
                <div className="font-medium" data-id="element-345">Correos electrónicos</div>
                <div className="text-sm text-gray-600" data-id="element-346">
                  Recibir comunicaciones por email
                </div>
              </div>
              <label className="relative inline-flex items-center cursor-pointer" data-id="element-347">
                <input type="checkbox" className="sr-only peer" defaultChecked data-id="element-348" />
                <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600" data-id="element-349"></div>
              </label>
            </div>
            <div className="flex items-center justify-between" data-id="element-350">
              <div data-id="element-351">
                <div className="font-medium" data-id="element-352">Alertas de acuerdos</div>
                <div className="text-sm text-gray-600" data-id="element-353">
                  Avisos sobre vencimientos
                </div>
              </div>
              <label className="relative inline-flex items-center cursor-pointer" data-id="element-354">
                <input type="checkbox" className="sr-only peer" defaultChecked data-id="element-355" />
                <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600" data-id="element-356"></div>
              </label>
            </div>
          </div>
        </Card>
        {/* Help & Legal */}
        <Card data-id="element-357">
          <div className="space-y-4" data-id="element-358">
            <button className="w-full flex items-center justify-between py-2" data-id="element-359">
              <div className="flex items-center" data-id="element-360">
                <HelpCircleIcon size={20} className="text-blue-600 mr-3" data-id="element-361" />
                <span data-id="element-362">Ayuda y soporte</span>
              </div>
              <span className="text-gray-400" data-id="element-363">›</span>
            </button>
            <button className="w-full flex items-center justify-between py-2" data-id="element-364">
              <div className="flex items-center" data-id="element-365">
                <FileTextIcon size={20} className="text-blue-600 mr-3" data-id="element-366" />
                <span data-id="element-367">Términos y condiciones</span>
              </div>
              <span className="text-gray-400" data-id="element-368">›</span>
            </button>
            <button className="w-full flex items-center justify-between py-2" data-id="element-369">
              <div className="flex items-center" data-id="element-370">
                <FileTextIcon size={20} className="text-blue-600 mr-3" data-id="element-371" />
                <span data-id="element-372">Política de privacidad</span>
              </div>
              <span className="text-gray-400" data-id="element-373">›</span>
            </button>
            <div className="pt-4 border-t" data-id="element-374">
              <button className="w-full text-center text-red-600 py-2" data-id="element-375">
                Cerrar sesión
              </button>
            </div>
          </div>
        </Card>
      </main>
    </div>;
};
export default Profile;